function ieVersion(): number | undefined {

  const ie = (function () {

    let undef, v = 3;
    const div = document.createElement('div'), all = div.getElementsByTagName('i');

    while (
      div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
      all[0]
    );
    return v > 4 ? v : undef;

  }());

  return ie;
}

export function checkIEVersion(): void {
  const iev = ieVersion();

  if ((typeof iev != 'undefined' && iev <= 9) || navigator.appVersion.indexOf("MSIE 10") !== -1) {
    window.location.href = 'https://www.breeio.com/incompatible/';
  }
}